import React, { useEffect, useState } from 'react';
import { AutoComplete, Button, Icon, Input, Spin, Tooltip } from "antd";
import { SearchOutlined, Loading } from '@ant-design/icons';
import { createDebounce } from '../../util/methods';
import { connect } from 'react-redux'
import { searchAuditVoucher } from '../../appRedux/actions';

const { Option } = AutoComplete;

const AuditVoucherSearch = ({
    styleName,
    width = '100%',
    placeholder,
    defaultAssetVoucher,
    onSelect,
    onClear,
    allowClear = false,
    ...props
}) => {

    const [vouchers, setVouchers] = useState([]);

    const debouncedSearch = createDebounce((searchValue) => {
        // console.log(searchValue)
        props.searchAuditVoucher(searchValue);
    }, 1000); // Adjust the delay (in milliseconds) as needed

    // useEffect(() => {
    //     console.log(props)
    // }, [props]);

    useEffect(() => {
        if (props.auditVoucherSearchData && props.auditVoucherSearchData.length)
            setVouchers(props.auditVoucherSearchData);
    }, [props.auditVoucherSearchData]);


    const handleSearch = value => {
        // setInputValue(value);
        if (value.length >= 3)
            debouncedSearch(value);
    };

    return (
        <AutoComplete
            className="global-search"
            // size="large"
            style={{ width }}
            dataSource={vouchers.map((item) => renderOption(item))}
            allowClear={allowClear}
            onSelect={(value, option) => onSelect && onSelect(value, vouchers.find(v => String(v._id) === String(value)))}
            onChange={(val) => { if (!val && onClear) onClear() }}
            onSearch={handleSearch}
            placeholder={defaultAssetVoucher ? defaultAssetVoucher.voucherNo : placeholder || "Search here ..."}
            optionLabelProp="text"
            // defaultActiveFirstOption={true}
            // defaultValue={defaultAsset && defaultAsset._id}
            // value={defaultAsset && defaultAsset.assetCode || ''}
            disabled={!!defaultAssetVoucher}
        >
            <Input
                suffix={
                    props.auditVoucherSearchLoading ? <Icon type="sync" spin />
                        : <SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />
                }
            />
        </AutoComplete>

    );

}


const mapStateToProps = ({ auditVoucher }) => ({
    auditVoucherSearchData: auditVoucher.auditVoucherSearchData,
    auditVoucherSearchLoading: auditVoucher.auditVoucherSearchLoading,

})

const mapDispatchToProps = { searchAuditVoucher }

export default connect(mapStateToProps, mapDispatchToProps)(AuditVoucherSearch)

function renderOption(item) {

    const { _id, voucherNo, name } = item;
    // console.log(item);
    let icon = 'bell';

    const recordName = `${voucherNo} (${name})`;
    // const url = `/asset/history-report/${_id}`;

    return recordName && (
        <Option key={_id} text={recordName}>
            <div className="global-search-item">
                <Tooltip title={recordName}>
                    {/*<i className={`icon ${icon} gx-fs-xs`} style={{float: 'left', marginRight: '5px'}}/>*/}
                    <Icon type={icon} style={{ float: 'left', marginRight: '10px', marginTop: '5px' }} />
                    <span style={{ marginLeft: '5px' }} className="global-search-item-count">{recordName}</span>
                </Tooltip>
            </div>
        </Option>
    );
}
